// extracted by mini-css-extract-plugin
export default {"container":"BN-z","darkBackground":"CN-z","whiteBackground":"DN-z","headerButton":"EN-z","calloutHeading":"FN-z","calloutSubHeading":"GN-z"};